import React, { useState } from 'react';

const Picker = ({ id, name, label, options, value, onChange, disabled, theme, placeholder }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const needle = value.trim().toLowerCase();
  const matches = options.filter((option) => option.name?.toLowerCase().includes(needle));

  const pick = (option) => {
    onChange({ target: { name, value: option.name } });
    setOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') return setOpen(false);
    if (event.key === 'Enter' && open && matches[active]) {
      event.preventDefault();
      return pick(matches[active]);
    }
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    setOpen(true);
    setActive((current) => (current + (event.key === 'ArrowDown' ? 1 : matches.length - 1)) % (matches.length || 1));
  };

  return (
    <label className="timesheets-field timesheets-picker">
      <span>{label}</span>
      <input
        type="text"
        name={name}
        role="combobox"
        aria-expanded={open}
        aria-controls={id}
        aria-autocomplete="list"
        autoComplete="off"
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={(event) => {
          setActive(0);
          setOpen(true);
          onChange(event);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onKeyDown={handleKeyDown}
        style={{ borderColor: theme.border, color: theme.text }}
      />
      <span className="timesheets-picker-caret" style={{ color: theme.secondaryText }}>
        ▾
      </span>

      {open && matches.length > 0 && (
        <ul
          id={id}
          role="listbox"
          className="timesheets-picker-list"
          style={{ background: theme.surface, borderColor: theme.border }}
        >
          {matches.map((option, index) => (
            <li
              key={option.id}
              role="option"
              aria-selected={index === active}
              className={index === active ? 'is-active' : undefined}
              onMouseDown={(event) => {
                event.preventDefault();
                pick(option);
              }}
              onMouseEnter={() => setActive(index)}
            >
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </label>
  );
};

export default Picker;
